import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";

import { Navbar } from "../../modules/ui/Navbar";
import {
    Box,
    Button,
    Container,
    CssBaseline,
    Divider,
    Grid,
    Stack,
    ThemeProvider,
    Typography,
    createTheme,
} from "@mui/material";
import { MuiDatePicker } from "../../modules/ui/MuiDatePicker";
import { getAllIn } from "../../../services/crudCustom";
import MUIDataTable from "mui-datatables";


const RECORD_INITIAL_STATE = {
    educonDescripcion: '',
    educonDuracion: '',
    educonFechaInicio: '',
    educonFechaTermino: '',
    educonLugar: '',
    educonTitulo: '',
    partApellidoMaterno: '',
    partApellidoPaterno: '',
    partCelular: '',
    partDiscapacidad: '',
    partEdad: '',
    partEmail: '',
    partEstatus: '',
    partGradoAcademico: '',
    partInstProcedencia: '',
    partLenguaIndigena: '',
    partNacionalidad: '',
    partNombres: '',
    partSexo: '',
    partTelefono: '',
    registroClaveProyecto: '',
    registroFecha: '',
    registroReferencia: '',
}


const columnOptions = {
    customBodyRender: val => <div style={{ width: "140px" }}>{ val }</div>
};

const textLabels = {
    body: {
        noMatch: "Ingresar datos",
        toolTip: "Ordenar",
        columnHeaderTooltip: column => `Ordenar por ${column.label}`
    },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Renglones por página:",
        displayRows: "de",
    },
    toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Mostrar Columnas",
        filterTable: "Filtrar tabla",
    },
    filter: {
        all: "Todo",
        title: "FILTROS",
        reset: "RESETEAR",
    },
    viewColumns: {
      title: "Mostrar Columnas",
    //   titleAria: "Show/Hide Table Columns",
    },
};

const educonsOptions = {
    print: false,
    search: false,
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: "460px",
    selectableRows: "none",
    rowsPerPage: 30,
    rowsPerPageOptions: [30, 60, 100],

    textLabels: textLabels,
};
const educonsColumns = [
    { name: "nombre",
        label: "Nombre",
        options: {
            filter: true,
            sort: true,
            setCellProps: () => ({
                style: {
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: "0",
                    background: "whitesmoke",
                    fontWeight: 600,
                    zIndex: 100,
                },
            }),
            setCellHeaderProps: () => ({
                style: {
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: 0,
                    background: "white",
                    fontWeight: 600,
                    textAlign: "center",
                    zIndex: 101,
                },
            }),
            customBodyRender: val => {
                let parentStyle = {
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  boxSizing: "border-box",
                  display: "block",
                  width: "100%"
                };
                let cellStyle = {
                  boxSizing: "border-box",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                };
                return (
                  <div style={{ position: "relative", height: "20px", width: "400px" }}>
                    <div style={ parentStyle }>
                      <div style={ cellStyle }>{ val }</div>
                    </div>
                  </div>
                );
              }
        },
    },
    { name: "fechaInicio", label: "Inicio", 
        options: {
            customBodyRender: (value) => (
                <span>
                    { `${value.substring(0,4)}-${value.substring(5,7)}-${value.substring(8,10)}` }
                </span>
            )
        }
    },
    { name: "fechaFin", label: "Termino", 
        options: {
            customBodyRender: (value) => (
                <span>
                    { `${value.substring(0,4)}-${value.substring(5,7)}-${value.substring(8,10)}` }
                </span>
            )
        }
    },
    { name: "cve_Proyec", label: "Proyecto", 
        options: {
            customBodyRender: (value) => (
                <span>
                    { value === '0' ? `No aplica` : value }
                </span>
            )
        }
    },
    { name: "modalidad", label: "Modalidad", },
];

const reportOptions = {
    print: false,
    search: false,
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    fixedHeader: true,
    fixedSelectColumn: false,
    tableBodyHeight: "460px",
    selectableRows: "none",
    rowsPerPage: 30,
    rowsPerPageOptions: [30, 60, 100],

    textLabels: textLabels,
};
const reportColumns = [
    { name: "registroReferencia",
        label: "Referencia",
        options: {
            filter: true,
            sort: true,
            setCellProps: () => ({
                style: {
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: "0",
                    background: "whitesmoke",
                    fontWeight: 600,
                    zIndex: 100,
                },
            }),
            setCellHeaderProps: () => ({
                style: {
                    whiteSpace: "nowrap",
                    position: "sticky",
                    left: 0,
                    background: "white",
                    fontWeight: 600,
                    textAlign: "center",
                    zIndex: 101,
                },
            }),
        },
    },
    { name: "partNombres", label: "Nombres", options: columnOptions, },
    { name: "partApellidoPaterno", label: "Apellido Paterno", options: columnOptions, },
    { name: "partApellidoMaterno", label: "Apellido Materno", options: columnOptions, },
    { name: "partInstProcedencia", label: "Institución de Procedencia", options: columnOptions, },
    { name: "partEstatus", label: "Estatus", options: columnOptions, },
    { name: "partEdad", label: "Edad", },
    { name: "partGradoAcademico", label: "Grado Académico", options: columnOptions, },
    { name: "partSexo", label: "Sexo", },
    { name: "partNacionalidad", label: "Nacionalidad", },
    { name: "partTelefono", label: "Teléfono", },
    { name: "partEmail", label: "Email", },
    { name: "partLenguaIndigena", label: "Lengua Indígena", options: columnOptions, },
    { name: "partDiscapacidad", label: "Discapacidad", options: columnOptions, },
    { name: "educonDescripcion", label: "Tipo de actividad", options: columnOptions, },
    { name: "educonTitulo", 
        label: "Nombre de la actividad", 
        options: {
            filter: true,
            sort: true,
            setCellProps: () => ({
                style: {
                    whiteSpace: "nowrap",
                    left: "0",
                },
            }),
            setCellHeaderProps: () => ({
                style: {
                    whiteSpace: "nowrap",
                    left: 0,
                    background: "white",
                    fontWeight: 600,
                    textAlign: "center",
                },
            }),
            customBodyRender: val => {
                let parentStyle = {
                  position: "absolute",
                  top: 0,
                  right: 0,
                  bottom: 0,
                  left: 0,
                  boxSizing: "border-box",
                  display: "block",
                  width: "100%"
                };
                let cellStyle = {
                  boxSizing: "border-box",
                  overflow: "hidden",
                  background: "white",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                };
                return (
                  <div style={{ position: "relative", height: "20px", width: "400px" }}>
                     <div style={ parentStyle }>
                      <div style={ cellStyle }>{ val }</div>
                     </div>
                  </div>
                );
              }
        },
    },
    { name: "educonLugar", label: "Lugar", options: columnOptions, },
    { name: "educonFechaInicio", label: "Fecha de Inicio", options: columnOptions, },
    { name: "educonFechaTermino", label: "Fecha de Termino", options: columnOptions, },
    { name: "educonDuracion", label: "Duración (horas)", options: columnOptions, },
];



export const Dashboard = () => {
    const cookies = new Cookies();
    const cookieId = cookies.get('id');

    const [formValues, setFormValues] = useState({
        startDate: null,
        endDate: null,
    });

    const [isSendButtonDisabled, setIsSendButtonDisabled] = useState(false);

    const [educonsData, setEduconsData] = useState([]);

    const [reportData, setReportData] = useState([]);


    const parseDateValue = (val) => {
        return val.substring(0, 10);
    }

    const parseDateTimeValue = (val) => {
        return `${ val.substring(0, 10) }, ${ val.substring(11, 19) } hrs.`;
    }

    function titleCase(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        }
        return splitStr.join(' '); 
     }

    // Al modificar un dato en un input
    const handleInputDateChange = ({ target }) => {
        const { name, value } = target;

        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    // Al presionar el boton "Consultar"
    const handleSubmit = async (event) => {
        event.preventDefault();
        // console.log({formValues});

        setIsSendButtonDisabled(true);
        
        //* Cargar actividades (educons)
        // Cargar todos los educons desde la view proporcionada por el area de sistemas
        const educonsGetAllIn = await getAllIn({ table:'EduconCursosRegistrados' });

        // Filtrar los educons que estan dentro del periodo indicado
        const educons = educonsGetAllIn.data.filter(item => {
            const educonInicio = new Date(item.fechaInicio);
            const educonFin = new Date(item.fechaFin);
            if (educonInicio >= formValues.startDate && educonFin <= formValues.endDate) {
                return item
            };
        })
        console.log("educons", educons);
        setEduconsData(educons);


        //* Cargar registros de cada una de esas actividades

        //! Version 2.0
        // Obtenemos los registros de participantes de las tablas
        // const { data: rRegistrosEducon } = await getAllIn({ table: "RegistrosEducon" });
        // console.log({rRegistrosEducon});
        
        const { data: rRegistroGeneral } = await getAllIn({ table: "RegistroGeneral" });
        console.log({rRegistroGeneral});


        // setIsSendButtonDisabled(false);


        //!

        // Obtenemos los registros de participantes de una de las tablas
        const { data: recordsRegistrosEducon } = await getAllIn({ table: "RegistrosEducon" });
        // console.log(recordsRegistrosEducon);
        
        // Inicializamos donde se van a cargar todos los registros (records) de los educons
        const records = [];
        // Para cada participante registrado
        recordsRegistrosEducon.forEach((item) => {
            // Se hace un parse de 'datosAdicionales' para obtener el educonId y educonInicio de cada participante
            const { educonId, educonInicio } = JSON.parse(item.datosAdicionales);
            // console.log({ educonId, educonInicio });

            // Obtenemos el educon al que corresponde a partir de 'folio' y 'educonInicio'
            const currentEducon = educons.filter( 
                (educon) => educon.folio === educonId && educon.fechaInicio === educonInicio
            )[0];
            // console.log({currentEducon});
            
            if (currentEducon) {
                
                const { descripcion, nombre, modalidad, fechaInicio, fechaFin, duracionHoras } = currentEducon;
    
                records.push({
                    partApellidoPaterno: titleCase(item.partApellidoPaterno),
                    partApellidoMaterno: titleCase(item.partApellidoMaterno),
                    partNombres: titleCase(item.partNombres),
                    partInstProcedencia: item.partInstProcedencia || null,
                    partEstatus: item.tipoRegistro,
                    partEdad: item.tipoEdad || null,
                    partGradoAcademico: item.partGradoAcademico || null,
                    partSexo: item.partSexo || null,
                    partTelefono: item.partTelefono || null,
                    partCelular: item.partCelular || null,
                    partEmail: item.partCorreo,
                    partLenguaIndigena: item.partLenguaIndigena || null,
                    partDiscapacidad: item.partDiscapacidad || null,
                    partNacionalidad: item.partPais || null,
    
                    educonDescripcion: descripcion || null,
                    educonTitulo: nombre || null,
                    educonLugar: modalidad || null,
                    educonFechaInicio: parseDateValue(fechaInicio) || null,
                    educonFechaTermino: parseDateValue(fechaFin) || null,
                    educonDuracion: duracionHoras || null,
    
                    registroClaveProyecto: item.claveProyecto,
                    registroFecha: parseDateTimeValue(item.registroFecha),
                    registroReferencia: item.registroReferencia,
                });
            }
        });

        // Obtenemos los registros de participantes de la tabla obsoleta
        const { data: recordsEducon } = await getAllIn({ table: "Educon" });

        recordsEducon.forEach((item) => {
            // console.log(item);

            // Obtenemos el educon al que corresponde a partir de 'folio'
            const  filterResult = educons.filter( 
                (educon) => educon.folio === Number(item.educonId)
            )[0];
            
            var descripcion = '';
            var nombre = '';
            var modalidad = '';
            var duracionHoras = '';

            if (filterResult) {
                descripcion = filterResult.descripcion;
                nombre = filterResult.nombre;
                modalidad = filterResult.modalidad;
                duracionHoras = filterResult.duracionHoras;
                
                records.push({
                    partApellidoPaterno: titleCase(item.partApellidoPaterno),
                    partApellidoMaterno: titleCase(item.partApellidoMaterno),
                    partNombres: titleCase(item.partNombres),
                    partInstProcedencia: item.partInstProcedencia || null,
                    partEstatus: item.tipoRegistro,
                    partEdad: item.tipoEdad || null,
                    partGradoAcademico: item.partGradoAcademico || null,
                    partSexo: item.partSexo || null,
                    partTelefono: item.partTelefono || null,
                    partCelular: item.partCelular || null,
                    partEmail: item.partCorreo,
                    partLenguaIndigena: item.partLenguaIndigena || null,
                    partDiscapacidad: item.partDiscapacidad || null,
                    partNacionalidad: item.partPais || null,
    
                    educonDescripcion: descripcion || null,
                    educonTitulo: nombre || null,
                    educonLugar: modalidad || null,
                    educonFechaInicio: null,
                    educonFechaTermino: null,
                    educonDuracion: duracionHoras || null,
    
                    registroClaveProyecto: item.claveProyRec,
                    registroFecha: item.fechaRegistro ? parseDateTimeValue(item.fechaRegistro) : null,
                    registroReferencia: item.refBancaria,
                });
            }

        });


        console.log({ records });

        setReportData(records);
        
        setIsSendButtonDisabled(false);
    };


    useEffect(() => {
        document.title = "Dashboard EDUCON";
        
        // Si no ha iniciado sesion, redirigir
        if (!cookieId ) {
            window.location.replace('../sign-in?p=educon/dashboard');
        }
    }, [ cookieId ])
    


    return (
        <>
            <Navbar nombre={cookies.get("nombre")} />
            <ThemeProvider theme={createTheme()}>
                <Container component="main">
                    <CssBaseline />

                    <Grid container spacing={1} sx={{ p: 2 }}  maxWidth="xl" >
                        <Box display="flex" flexDirection="row" flex={1}>
                            <Grid item xs={12}>
                                <Typography variant="h4">
                                    Dashboard EDUCON
                                </Typography>
                                <Typography variant="title1">
                                    Reporte general
                                </Typography>
                            </Grid>
                        </Box>
                        <Box
                            autoComplete="off"
                            component="form"
                            display="flex"
                            flexDirection="row"
                            onSubmit={handleSubmit}
                            noValidate
                            sx={{ mt: 2 }}
                        >
                            <MuiDatePicker
                                name="startDate"
                                label="Inicio"
                                parentCallback={handleInputDateChange}
                            />

                            <Divider orientation="vertical" flexItem>
                                hasta el
                            </Divider>

                            <MuiDatePicker
                                name="endDate"
                                label="fin del periodo"
                                parentCallback={handleInputDateChange}
                            />

                            <Box sx={{ mx: 1, my: "auto" }}>
                                <Button
                                    type="submit"
                                    disabled={ 
                                        (!formValues.startDate || !formValues.endDate) || 
                                        isSendButtonDisabled 
                                    }
                                    fullWidth
                                    variant="contained"
                                >
                                    Consultar
                                </Button>
                            </Box>
                        </Box>
                        <Grid item xs={12} >
                        </Grid>
                    </Grid>

                    {
                        educonsData.length > 0
                        ? (
                            <>
                                <Stack direction="column" marginTop={ 1 }>
                                    <MUIDataTable
                                        title={ "EDUCONS" }
                                        data={ educonsData }
                                        columns={ educonsColumns }
                                        options={ educonsOptions }
                                    />
                                </Stack>
        
                                <Stack direction="column" marginTop={ 1 } marginBottom={ 6 }>
                                    <MUIDataTable
                                        title={ "Registros de participantes" }
                                        data={ reportData }
                                        columns={ reportColumns }
                                        options={ reportOptions }
                                    />
                                </Stack>
                            </>
                        )
                        : (
                            <Box display="flex" flexDirection="row" sx={{ mt: 4 }} >
                                <Typography variant="h3">
                                    Ingresa el periodo para ver resultados.
                                </Typography>
                            </Box>
                        )
                    }

                </Container>
            </ThemeProvider>
        </>
    );
};
